import { TextField, Button } from "@mui/material";
import { CloudUpload, FileDownload } from "@mui/icons-material";
import { apiUrl } from "../../config/config";

const ParcelOwnerForm = ({
  formData,
  errors,
  handleChange,
  handleFieldFocus,
  handleFileDocumentChange,
  newFile = {
    file: null,
    document_parcelle: null,
  },
  action = "ajout",
}) => (
  <div className="flex flex-col justify-center items-center space-y-5 mt-8 mb-8">
    <TextField
      label="Nom du propriétaire de la parcelle"
      fullWidth
      size="small"
      value={formData.prop_nom}
      onChange={(e) =>
        handleChange("prop_nom", e.target.value.toLocaleUpperCase())
      }
      onFocus={() => handleFieldFocus("prop_nom")}
      error={!!errors.prop_nom}
      helperText={errors.prop_nom}
      required
    />
    <TextField
      label="Prénom du propriétaire de la parcelle"
      fullWidth
      size="small"
      value={formData.prop_prenom}
      onChange={(e) =>
        handleChange("prop_prenom", e.target.value.toLocaleUpperCase())
      }
      onFocus={() => handleFieldFocus("prop_prenom")}
      error={!!errors.prop_prenom}
      helperText={errors.prop_prenom}
      required
    />
    <TextField
      label="Section"
      fullWidth
      size="small"
      value={formData.section}
      onChange={(e) => handleChange("section", e.target.value.toUpperCase())}
      onFocus={() => handleFieldFocus("section")}
      error={!!errors.section}
      helperText={errors.section}
      required
    />
    <TextField
      label="Lot"
      fullWidth
      size="small"
      value={formData.lot}
      onChange={(e) => handleChange("lot", e.target.value)}
      onFocus={() => handleFieldFocus("lot")}
      error={!!errors.lot}
      helperText={errors.lot}
      type="number"
      required
    />
    <TextField
      label="Parcelle"
      fullWidth
      size="small"
      value={formData.parcelle}
      onChange={(e) => handleChange("parcelle", e.target.value)}
      onFocus={() => handleFieldFocus("parcelle")}
      type="number"
      error={!!errors.parcelle}
      helperText={errors.parcelle}
      required
    />
  
    {action === "ajout" && (
      <>
        <p className="mt-2 mb-2 text-sm text-yellow-400 font-bold">
          Importez le Document de votre parcelle en pdf (2Mo maximum)
        </p>
        <Button
          component="label"
          role={undefined}
          variant="contained"
          tabIndex={-1}
          startIcon={<CloudUpload />}
        >
          Importer le document
          <input
            type="file"
            accept=".pdf"
            hidden
            onChange={(event) => handleFileDocumentChange(event)}
          />
        </Button>
        {formData.document_parcelle && (
          <p className="text-green-700">{formData.document_parcelle.name}</p>
        )}
        {errors.document_parcelle && (
          <p className="mt-2 text-sm text-red-600 dark:text-red-500">
            {errors.document_parcelle}
          </p>
        )}
      </>
    )}

    {action === "modification" && (
      <>
        <Button
          component="label"
          role={undefined}
          variant="contained"
          tabIndex={-1}
          startIcon={<CloudUpload />}
        >
          Modifier le Document de votre parcelle
          <input
            type="file"
            accept=".pdf"
            hidden
            onChange={(event) => handleFileDocumentChange(event)}
          />
        </Button>
        <p className="mt-2 mb-2 text-sm text-yellow-400 font-bold">
          Le fichier doit etre en pdf (2Mo maximum)
        </p>
        {newFile.document_parcelle && (
          <>
            <strong>Nouveau fichier:</strong>
            <div className={`text-blue-800`}>
              {newFile.document_parcelle.name}
            </div>
          </>
        )}
        {formData.document_parcelle && (
          <>
            <a
              href={apiUrl + `/storage/${formData.document_parcelle}`}
              target="_blank"
              rel="noreferrer"
            >
              <FileDownload color={`primary`} sx={{ fontSize: 40 }} />
            </a>
            {formData.document_parcelle}
          </>
        )}
        {errors.document_parcelle && (
          <p className="mt-2 text-sm text-red-600 dark:text-red-500">
            {errors.document_parcelle}
          </p>
        )}
      </>
    )}
  </div>
);

export default ParcelOwnerForm;
